import { render } from "./TransformationIcon.vue?vue&type=template&id=7724328d"
import script from "./TransformationIcon.vue?vue&type=script&lang=js"
export * from "./TransformationIcon.vue?vue&type=script&lang=js"
script.render = render

export default script